"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileTag = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const TileTag = ({ learningType, deliveryTypes }) => {
    const isNeedHyphen = (learningType) => {
        return learningType === 'course' ? '-' : null;
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: learningType && ((0, jsx_runtime_1.jsxs)("div", { className: "py-4xs px-md rounded-3xl bg-fill-secondary border-sm border-inverse inline-block body-sm", children: [(0, app_1.capitalizeFirstLetter)(learningType), " ", isNeedHyphen(learningType), ' ', deliveryTypes && deliveryTypes.join(', ')] })) }));
};
exports.TileTag = TileTag;
